$(window).on('scroll load', function(){
    var scroll = $(this).scrollTop();
    var windowHeight = $(window).height();
    $('.fade_in').each(function(){
    var cntPos = $(this).offset().top;
        if(scroll > cntPos - windowHeight + windowHeight / 3){
        $(this).addClass('animated');
        }
    });
});

jQuery(function ($) { 
    if ($('body .store_tab')  && $('body .store.is-active').offset()) {
        $('body .store_tab').scrollLeft($('body .store.is-active').offset().left);
    }

    $(".topics__list--01").on('click', function () {
        $(this).addClass("is-active");
        $(".topics__list--02").removeClass("is-active");
        $(".topics__list--03").removeClass("is-active");
    });

    $(".topics__list--02").on('click', function () {
        $(this).addClass("is-active");
        $(".topics__list--01").removeClass("is-active");
        $(".topics__list--03").removeClass("is-active");
    });

    $(".topics__list--03").on('click', function () {
        $(this).addClass("is-active");
        $(".topics__list--01").removeClass("is-active");
        $(".topics__list--02").removeClass("is-active");
    });

    $('.store').on('click', function(){
        $('.store_tab li').removeClass('is-active');
        $(this).addClass('is-active')
    })
});